import { RADIUS_SEARCH, API_CONFIG, I18N } from '../../globals/wp';

const radius = parseInt(RADIUS_SEARCH, 10);

export const imperial = API_CONFIG.units === 'imperial';
export const maxDistance = imperial ? radius : radius * 1.609344;
export const translated = imperial ? I18N.miles : I18N.km;

export const getMaxDistance = (currentRadius) => {
	const radius = parseInt(currentRadius, 10);
	return imperial ? radius : radius * 1.609344;
};


// WEBPACK FOOTER //
// ./src/utils/data/units.js